import {EducationLevel, ProfessionalField, ProfessionalType, QualificationType} from './CommonModels';

export class ProfessionalTypeConfig {
    applicationCategoryID: number;
    productTypeID: number;
    facilityTypeID: number;
    manufacturingLevelID: number;
    manufacturingRiskLevelID: number;
    changeTypeRefID: number;
    professionalTypeID: number;
    professionalType: ProfessionalType;
    active: boolean;
    required: boolean;
    educationLevelConfig: EducationLevelConfig[];
    professionalFieldConfig: ProfessionalFieldConfig[];
    id: number;
    isActive: boolean;
    createdDate: string;
    modifiedDate: string;
    rowGuid: string;

    constructor(){
      this.educationLevelConfig = new Array<EducationLevelConfig>();
      this.professionalFieldConfig = new Array<ProfessionalFieldConfig>();
    }
}


export class ProfessionalFieldConfig {
      professionalFieldID: number;
      professionalTypeConfigID: number;
      active: boolean;
      required: boolean;
      professionalField: ProfessionalField;
      id: number;
      isActive: boolean;
      createdDate: string;
      modifiedDate: string;
      rowGuid: string;
}

export class EducationLevelConfig {
      professionalTypeConfigID: number;
      educationLevelID: number;
      qualificationConfig: QualificationConfig[];
      id: number;
      isActive: boolean;
      createdDate: string;
      modifiedDate: string;
      rowGuid: string;
      educationLevel: EducationLevel;

      constructor(){
        this.qualificationConfig = new Array<QualificationConfig>();
      }
}

export class QualificationConfig {
      educationLevelConfigID: number;
      qualificationID: number;
      specificProductItemID: number;
      minExperience: number;
      id: number;
      isActive: boolean;
      isSelected: boolean;
      createdDate: string;
      modifiedDate: string;
      rowGuid: string;
      qualification: QualificationType;
}

export class ProfessionalConfigFilter {
  applicationCategoryID: number;
  facilityTypeID: number;
  productTypeID: number;
  changeTypeRefIDs: number[];
  manufacturingLevelID: number;
  manufacturingRiskLevelID: number;
  professionalTypeID: number;
  specificProductItemIDs: number[];
}
